import { actions } from "@app/utils";
import { createApiClient } from "@app/utils/apiClient";

export const jobsClient = createApiClient(actions["exd-storyteller-ai/jobs"]);

export const getJobStatus = async (jobId, options = {}) => {
  const response = await jobsClient.post("/poll-status", { jobId }, options);

  if (!response.ok) {
    throw new Error("Failed to poll job status", { cause: response });
  }

  return response.data;
};

export const listJobs = async (params = {}, options = {}) => {
  const response = await jobsClient.post(
    "/list",
    params ?? {},
    options,
  );

  if (!response.ok) {
    throw new Error("Failed to list mogrt jobs", {
      cause: response.data,
    });
  }

  return response.data;
};

export const jobsPollStatus = async (
  { jobId },
  interval = 1000,
  options = {},
) => {
  return new Promise((resolve, reject) => {
    const poll = setInterval(async () => {
      try {
        const response = await jobsClient.post(
          "/poll-status",
          {
            jobId,
          },
          options,
        );

        if (!response.ok) {
          clearInterval(poll);
          reject(new Error("Failed to poll job status", { cause: response }));
          return;
        }

        const statusData = response.data;

        if (statusData.status === "completed") {
          clearInterval(poll);
          resolve(statusData);
        } else if (statusData.status === "failed") {
          clearInterval(poll);
          reject(new Error("Job failed", { cause: statusData }));
        }
        // Continue polling if status is still pending/processing
      } catch (error) {
        clearInterval(poll);
        reject(error);
      }
    }, interval);
  });
};
